const clearCache = (key: string): void => {
  const data = localStorage.getItem(key)
  if (data) {
    localStorage.removeItem(key)
  }
}

export default clearCache
